import React, { Component } from 'react';
import { observer } from 'mobx-react';

import { AgGridReact } from 'ag-grid-react';
import LabDetailsSummary from './LabDetailsSummary';

const height = window.innerHeight * .65;

const defaultColDef = {
    sortable: true,
    resizable: true,
    filter: true,
    flex: 1,
};

const dueGetter = (params) => {
    return params.data.Total - params.data.PaidAmount;
};

const columnDefs = [
    { headerName: 'Date', field: 'CreatedOn', width: 75 },
    { headerName: 'SidCode', field: 'SidCode', width: 100 },
    { headerName: 'Patient Name', field: 'CustomerName', filter: 'agTextColumnFilter', width: 350 },
    { headerName: 'TestOrProfileName', field: 'TestOrProfileName', filter: 'agTextColumnFilter', width: 350 },
    { headerName: 'Bill', field: 'Total', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Received', field: 'PaidAmount', type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Due', field: 'Due', valueGetter: dueGetter, type: 'numericColumn', filter: 'agNumberColumnFilter', headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
    { headerName: 'Bucket', field: 'Bucket', type: 'numericColumn', filter: 'agNumberColumnFilter', width: 125, headerClass: 'ag-right-aligned-header', cellClass: 'ag-right-aligned-cell' },
]

class LabDetails extends Component {

    gridRef = React.createRef();

    constructor(props) {
        super(props);
        this.store = props.store;
    }

    fetchSummary = () => {
        this.store.fetchSummary(this.props.params.collectionType);
    }

    refreshGrid = () => {
        this.gridRef.current.api.redrawRows();
    }

    render() {
        return (  
            <div>
                <div className="ag-theme-alpine" style={{ height: height, width: '100%' }}>
                    <AgGridReact
                        ref={this.gridRef}
                        defaultColDef={defaultColDef}
                        rowData={this.store.receivables}
                        columnDefs={columnDefs}
                        rowSelection={'single'}
                        onSelectionChanged={this.onSelectionChanged}
                        onGridReady={this.fetchSummary}
                        rowHeight={25}
                    >
                    </AgGridReact>
                </div>
                <div>
                    <LabDetailsSummary store={this.store} />
                </div>
            </div>
        )
    }
}

export default observer(LabDetails)
